import axios from "axios";

const state = () => ({
  loading: false,
  items: [],
  itemsTotal: 0,
  page: 1,
  firstLoad: true,
  length: 2,
  pageCount: 1,
  search: "",
  allItems: [],

  listDialog: false,

  isNextPage: null,
});

const mutations = {
  setLoading(state, loading) {
    state.loading = loading;
    if (!loading) state.firstLoad = false;
  },

  setLength(state, length) {
    state.length = length;
  },

  setPage(state, page) {
    state.page = page;
  },

  setSearch(state, search) {
    state.search = search;
  },

  setItemsTotal(state, itemsTotal) {
    state.itemsTotal = itemsTotal;
  },

  setPageCount(state, pageCount) {
    state.pageCount = pageCount;
  },

  setItems(state, items) {
    state.items = items;
  },

  setAllItems(state, allItems) {
    state.allItems = allItems;
  },

  addItems(state, allItems) {
    if (state.page === 1) state.allItems = [];

    if (state.items.length < 1) {
      state.allItems = allItems;
    } else {
      state.allItems = state.allItems.concat(allItems);
    }
  },

  setListDialog(state, listDialog) {
    state.listDialog = listDialog;
  },

  setIsNextPage(state, isNextPage) {
    state.isNextPage = isNextPage;
  },
};

const actions = {
  /**
   * @description Gets paginated Profitable Trades list
   * @param {*} { commit, state }
   * @param {Boolean, Dict} { isCancle = false, dataTableParams }
   */
  async getProfitableTrades({ commit, state }, params) {
    params["page"] = state.page;
    params["page_size"] = state.length;
    params["status"] = "Inactive";
    params["pandl_data__gt"] = 0;
    var date = new Date();
    date.setDate(date.getDate() - 7);
    params["created__gte"] = date;

    commit("setLoading", true);
    // const response = await this.$eventApi.eventList(params, isCancle);
    let user_id = localStorage.getItem("user_id");

    const response = await axios.get(`/api/trade/${user_id}/trending/`, {
      params: params,
    });

    if (/^[2]/.test(response.status)) {
      commit("setItems", response.data.results);
      commit("addItems", response.data.results);
      commit("setItemsTotal", response.data.count);
      commit("setIsNextPage", response.data.next);

      if (response.data.count / state.length > 0)
        commit("setPageCount", Math.ceil(response.data.count / state.length));
      else commit("setPageCount", 1);
    } else if (response.data.data.message) {
      //
    }
    commit("setLoading", false);
  },

  /**
   * @description Responsible to load next page
   * @param {*} { commit, state }
   */
  loadNextPage({ commit, state }) {
    commit("setPage", state.page + 1);
  },

  /**
   * @description Responsible to load specified page
   * @param {*} { commit, state }
   * @param {*} page
   */
  loadPage({ commit }, page) {
    commit("setPage", page);
  },

  /**
   * @description Resets page to 1
   * @param {*} { commit, state }
   */
  resetPage({ commit }) {
    commit("setAllItems", []);
    commit("setPage", 1);
    commit("setSearch", "");
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
